import { isPast, addHours } from 'date-fns'

const storage = sessionStorage

function revalidate(key: string): void {
  const value = storage.getItem(key)
  if (value === null) {
    return
  }

  const parsedValue = JSON.parse(value)
  if (isPast(new Date(parsedValue.ttl))) {
    storage.removeItem(key)
  }
}

function init() {
  const cacheKeys = []

  for (let index = 0; ; index++) {
    const key = storage.key(index)
    if (key === null) {
      break
    }
    if (key.substring(0, 6) === '@cache') {
      cacheKeys.push(key)
    }
  }

  cacheKeys.forEach(key => {
    revalidate(key)
  })
}

function setItem<T>(
  key: string,
  value: T,
  ttl: Date = addHours(new Date(), 3),
) {
  const safeValue = JSON.stringify({
    ttl: ttl.toISOString(),
    value,
  })
  storage.setItem(`@cache:${key}`, safeValue)
}

function getItem(key: string) {
  const value = storage.getItem(`@cache:${key}`)

  revalidate(key)

  if (value === null) {
    return null
  }

  const parsedValue = JSON.parse(value)

  return parsedValue.value
}

function removeItem(key: string) {
  const value = storage.getItem(`@cache:${key}`)
  storage.removeItem(`@cache:${key}`)

  if (value === null) {
    return null
  }

  const parsedValue = JSON.parse(value)

  return parsedValue.value
}

init()

export { getItem, setItem, removeItem }
